import * as React from "react"
import { Select, Stack } from "@chakra-ui/react"

import { useTableParams } from "lib/hooks/useTableParams"
import { categories } from "lib/static/filters"

export interface TutorialFilters {
  category: string
}
interface TutorialsFilterbarProps {
  filters: TutorialFilters
  onSetFilters: (filters: TutorialFilters) => void
}

export const TutorialsFilterbar: React.FC<TutorialsFilterbarProps> = (props) => {
  const [_, setParams] = useTableParams()
  const tutorialFilters = props.filters

  const setTutorialFilters = ({ filter, value }: { filter: keyof TutorialFilters; value: string }) => {
    props.onSetFilters({ ...tutorialFilters, [filter]: value })
    setParams({ [filter]: value })
  }

  return (
    <Stack spacing={4} direction={{ base: "column", lg: "row" }}>
      <Select
        placeholder="Alle categorieën"
        value={tutorialFilters.category}
        onChange={({ target: { value } }) => setTutorialFilters({ filter: "category", value })}
        aria-label="selecteer categorie"
      >
        {categories.map((category, i) => (
          <option key={i} value={category}>
            {category}
          </option>
        ))}
      </Select>
    </Stack>
  )
}
